module.exports = __webpack_public_path__ + "img/play-1.38f65fb6.png";